/**
 * Copia texto para a area de transferencia.
 *
 * `navigator.clipboard` so existe em contexto seguro (https ou localhost); acessando
 * pelo IP da rede (http://192.168...) ele e undefined. Nesse caso cai no
 * `execCommand('copy')`, que precisa rodar dentro do clique do usuario.
 *
 * @param {string} text
 * @returns {Promise<boolean>} true se copiou
 */
export async function copyText(text) {
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);

      return true;
    } catch (error) {
      // segue para o fallback
    }
  }

  const textArea = document.createElement('textarea');

  textArea.value = text;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.select();

  try {
    return document.execCommand('copy');
  } catch (error) {
    return false;
  } finally {
    document.body.removeChild(textArea);
  }
}

export default { copyText };
